import { memoize } from 'lodash';

function composeValidators(fieldName, ...validators) {
  return value =>
    validators.reduce(
      (error, validator) => error || validator(fieldName)(value),
      undefined
    );
}

const memoizedComposeValidators = memoize(composeValidators);

export { memoizedComposeValidators as composeValidators };
